import DataSetManager from './DataSetManager';
import axios from 'axios';

export default class APIClient {
	constructor(store) {
		this.store = store;
	}
	
	async getPhotoAlbumListOfProject (project_id) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		
		let url = '/api/v1/photoalbum/album_list/project';
		return await axios.get(url, {
			params: {
				'contractor_id': access_token.iss,
				'project_id': project_id,
				'login_id': access_token.sub
			},
			headers: {
				Authorization: `Bearer ${access_token.token}`,
			},
		});
	}
	
	async getPhotoAlbumListOfSchedule (schedule_id) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		
		let url = '/api/v1/photoalbum/album_list/schedule';
		return await axios.get(url, {
			params: {
				'contractor_id': access_token.iss,
				'schedule_id': schedule_id,
				'login_id': access_token.sub
			},
			headers: {
				Authorization: `Bearer ${access_token.token}`,
			},
		});
	}
	
	async getPhotoAlbum (photpalbum_id) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		
		let url = '/api/v1/photoalbum/' + photpalbum_id + '/';
		
		return await axios.get(url, {
			params: {
				'contractor_id': access_token.iss,
			},
			headers: {
				Authorization: `Bearer ${access_token.token}`,
			},
		});
	}

	async updatePhotoAlbum (photoalbum_id, data) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		return await axios
			.put('/api/v1/photoalbum/' + photoalbum_id + '/', Object.assign({
				'contractor_id': access_token.iss,
				'socketio_id': this.store.getters.socketioID,
			}, data), {
				headers: {
					Authorization: `Bearer ${access_token.token}`,
				},
			})
	}
	
	async appendPhotoAlbumItems (photoalbum_id, items) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		
		return await axios.post('/api/v1/photoalbum/' + photoalbum_id + '/appendItems', {
				'contractor_id': access_token.iss,
				'socketio_id': this.store.getters.socketioID,
				'items': items,
			}, {
				headers: {
					Authorization: `Bearer ${access_token.token}`,
				},
			}).then((res) => {
				return res;
			}).catch((e) => {
				throw e;
			});
	}
	
	async deletePhotoAlbumItems (photoalbum_id, items) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		
		return axios
			.post('/api/v1/photoalbum/' + photoalbum_id + '/deleteItems', {
				'contractor_id': access_token.iss,
				'socketio_id': this.store.getters.socketioID,
				'items': items.map((item) => { return {'id': item.id}}),
			}, {
				headers: {
					Authorization: `Bearer ${access_token.token}`,
				},
			});
	}

	async deletePhotoAlbum (photoalbum_id) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		
		return axios
			.delete('/api/v1/photoalbum/' + photoalbum_id + '/', {
				params: {
					'contractor_id': access_token.iss,
					'socketio_id': this.store.getters.socketioID,
				},
				headers: {
					Authorization: `Bearer ${access_token.token}`,
				},
			});
	}

	async createTalkMessagePhotoAlbum(talkroom_id, photoalbum_id, title, items) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		
		return await axios
			.post('/api/v1/talkroom/' + talkroom_id + '/', {
				'contractor_id': access_token.iss,
				'socketio_id': this.store.getters.socketioID,
				'type': 'photoalbum',
				'photoalbum_id': photoalbum_id,
				'title': title,
				'items': items,
			}, {
				headers: {
					Authorization: `Bearer ${access_token.token}`,
				},
			});
	}

	async createPhotoAlbum(album_id, project_id, items, title) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		
		let params = {
			'contractor_id': access_token.iss,
			'socketio_id': this.store.getters.socketioID,
			'album_id': album_id,
			'items': items,
			'title': title,
			'project_id': project_id,
		};
		let url = '/api/v1/photoalbum/';
		return await axios.put(url, params, {
				headers: {
					Authorization: `Bearer ${access_token.token}`,
				},
			}).then((res) => {
				return res;
			}).catch((e) => {
				throw e;
			});
	}

	async getTalkRoomInfo(talkroom_id, count, threshold_id, newer) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
			
		return await axios.get('/api/v1/talkroom/' + talkroom_id, {
			params: {
				'contractor_id': access_token.iss,
				'count': count,
				'threshold_id': threshold_id,
				'newer': newer,
			},
			headers: {
				Authorization: `Bearer ${access_token.token}`,
			},
		});
	}

	async getContractor() {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		return await axios.get('/api/v1/contractor', {
			params: {
				'contractor_id': access_token.iss,
			},
			headers: {
				Authorization: `Bearer ${access_token.token}`,
			},
		});
	}

	async searchTalkRoom(project_code, member_code, schedule_code) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		return await axios.get('/api/v1/talkroom', {
			params: {
				'contractor_id': access_token.iss,
				'project_id': project_code,
				'member_id': member_code,
				'schedule_id': schedule_code,
			},
			headers: {
				Authorization: `Bearer ${access_token.token}`,
			},
		});
	}
	
	async createTalkRoom(project_code, member_code, schedule_code) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		
		const params = new URLSearchParams();
		params.append('socketio_id', this.store.getters.socketioID);
		params.append('contractor_id', access_token.iss);
		params.append('project_id', project_code);
		params.append('member_id', member_code);
		params.append('schedule_id', schedule_code);
		return await axios.put('/api/v1/talkroom', params, {
			headers: {
				Authorization: `Bearer ${access_token.token}`,
			},
		});
	}

	async downloadArchive(project_id, member_id, schedule_id, photoalbum_id, socketio_id, items, archive_type) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};

		if (!photoalbum_id)
			photoalbum_id = [];
		if (!Array.isArray(photoalbum_id))
			photoalbum_id = [photoalbum_id];
		if (!items)
			items = [];
		
		const params = new URLSearchParams();
		params.append('contractor_id', access_token.iss);
		params.append('project_id', project_id);
		params.append('member_id', member_id || '');
		params.append('schedule_id', schedule_id  || '');
		photoalbum_id.forEach(id => {
			params.append('photoalbum_id', id);
		});
		items.forEach((item) => {
			params.append('item_id', item);
		});
		params.append('archive_type', archive_type);
		params.append('socketio_id', socketio_id);
		return await axios.post('/api/v1/photoalbum/archive', params, {
			headers: {
				Authorization: `Bearer ${access_token.token}`,
			},
		});
	}

	async updateBrowseHistory(album_id) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		const params = new URLSearchParams();
		params.append('contractor_id', access_token.iss);
		params.append('login_id', access_token.sub);
		
		return await axios.post('/api/v1/photoalbum/' + album_id + '/browse', params, {
			headers: {
				Authorization: `Bearer ${access_token.token}`,
			},
		});
	}

	async getPhotoAlbumScheduleList(cond) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		return await axios.get('/api/v1/photoalbum/schedule_list/schedule', {
			params: Object.assign({
				'contractor_id': access_token.iss,
				'login_id': access_token.sub,
			}, cond),
			headers: {
				Authorization: `Bearer ${access_token.token}`,
			},
		});
	}

	async getPhotoAlbumScheduleListReference(cond) {
		let access_token = await DataSetManager.confirmAccessToken(this.store);
		if(!access_token)
			throw {
				token: 'can not set access token.',
			};
		return await axios.get('/api/v1/photoalbum/schedule_list/reference', {
			params: Object.assign({
				'contractor_id': access_token.iss,
				'login_id': access_token.sub,
			}, cond),
			headers: {
				Authorization: `Bearer ${access_token.token}`,
			},
		});
	}
}
